import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Service from './pages/Service';
import Promotion from './pages/Promotion';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Condominium from "./pages/.Condominium";
import SemiD from './pages/.Semi-D';
import Commercial from './pages/.Commercial';
import Landed from './pages/.Landed';
import ProjectDetail from "./pages/ProjectDetail";
import ScrollToTopButton from "./components/ScrollToTopButton";
import ThankYou from './pages/ThankYou';
import emailjs from '@emailjs/browser';
emailjs.init("rUCdgM9MIRAjjBqyY"); // Your Public Key



function App() {
    return (
        <Router>
            <Navbar />
                <Routes>
                    <Route path = "/" element = {<Home />} />
                    <Route path = "/service" element = {<Service />} />
                    <Route path = "/promotion" element = {<Promotion />} />
                    <Route path = "/gallery" element = {<Gallery />} />
                    <Route path = "/contact" element = {<Contact />} />
                    <Route path = "/condominium" element = {<Condominium />} />
                    <Route path = "/semi-d" element = {<SemiD />} />
                    <Route path = "/commercial" element = {<Commercial />} />
                    <Route path = "/landed" element = {<Landed />} />
                    <Route path="/project/:id" element={<ProjectDetail />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                </Routes>
                <ScrollToTopButton />

            <Footer/>
        </Router>
    );
}

export default App;
